import type { HeadersFunction, LoaderFunction, MetaFunction } from '@remix-run/node';
import { useLoaderData } from '@remix-run/react';

import StaticPage from '~/components/StaticPage';

import getStaticPageMetaData from '~/utils/getStaticPageMetaData';
import getUnnormalizedCategory from '~/utils/getUnnormalizedCategory';
import { shouldRevalidateLoaderData } from '~/utils/shouldRevalidateLoaderData';

import { staticPageClientLoader } from '~/components/StaticPage/staticPageClientLoader';
import { staticPageLoader } from '../../services/static_page';

export const headers: HeadersFunction = ({ loaderHeaders }) => {
  return {
    'cache-control': loaderHeaders.get('cache-control') || 'max-age=0', // no-cache
    'Cache-Tag': 'orchid-page',
  };
};

export const meta: MetaFunction<typeof loader> = (args) => {
  const { params } = args;
  const tag = params.tag || '';
  const tagName = getUnnormalizedCategory(tag);

  const overrideData = {
    title: tagName,
  };

  return getStaticPageMetaData(args, overrideData);
};
export const loader: LoaderFunction = async ({ request, params }) => {
  const tag = params?.tag || '';
  const tagText = getUnnormalizedCategory(tag);

  return staticPageLoader({
    request,
    pageRequestParams: {
      pathname: 't/$tag',
      tagPageHeaderDisplay: tagText,
    },
  });
};

export const clientLoader = staticPageClientLoader;

const Tag = () => {
  const { site, page } = useLoaderData<typeof loader>();

  return <StaticPage page={page} site={site} />;
};

export const shouldRevalidate = shouldRevalidateLoaderData;

export default Tag;
